<template>
  <label
    class="inline-flex flex-row flex-no-wrap items-center cursor-pointer leading-none text-sm"
  >
    <input
      @change="$emit('change', $event)"
      type="radio"
      :value="value"
      :checked="checked"
      class="hidden"
    />
    <span
      class="
        min-w-24px
        h-6
        circle
        inline-flex
        border
        border-solid
        border-neutral-400
        rounded-full
        p-0"
        :class="[sizeHandler, { 'mr-3': $slots.default, ' border-primary-100': checked }]"
    >
      <i
        class="
        pointer
        inline-block
        bg-primary-100
        rounded-full
        m-auto
        "
        :class="`pointer_${size}`"
      ></i>
    </span>
    <slot />
  </label>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      modifiers: {
        default: 'w-4 h-4',
        large: 'w-5 h-5',
      },
    };
  },
  computed: {
    sizeHandler() {
      return this.modifiers[this.size];
    },
  },
};
</script>

<style lang="scss">
.pointer {
  &_big {
    min-width: 16px;
    width: 16px;
    height: 16px;
  }
  &_large {
    min-width: 12px;
    width: 12px;
    height: 12px;
  }
  &_default {
    min-width: 8px;
    width: 8px;
    height: 8px;
  }
}
input {
  & + .circle .pointer {
    visibility: hidden;
  }

  &:checked + .circle .pointer {
    visibility: visible;
    background-color: #00A072;
  }
}
</style>
